// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { LocalStorage } from "../../Commons/LocalStorage.js"

export let BrokerMessageCustomButton = function ()
{
    this.fTitle = null
    this.fTooltip = null
    this.fURL = null
    this.fAliases = null
}

Object.defineProperty(BrokerMessageCustomButton.prototype, 'Title', {
    get: function ()
    {
        let result = this.fTitle
        if (this.fAliases)
        {
            let alias = this.fAliases[LocalStorage.getLanguage()]
            if (alias && alias.Name)
                result = alias.Name
        }
        return result
    }
})
Object.defineProperty(BrokerMessageCustomButton.prototype, 'Tooltip', {
    get: function ()
    {
        let result = this.fTooltip
        if (this.fAliases)
        {
            let alias = this.fAliases[LocalStorage.getLanguage()]
            if (alias && alias.Description)
                result = alias.Description
        }
        return result
    }
})
Object.defineProperty(BrokerMessageCustomButton.prototype, 'URL', { get: function () { return this.fURL } })
Object.defineProperty(BrokerMessageCustomButton.prototype, 'TitleForResponse', { get: function () { return this.fTitle } })